import axios from 'axios';
import { MAPPING } from '../../helpers';
import { CONFIG } from '../../../../../environments';

export const fetchZipCode = () => axios.get(CONFIG.ENDPOINT.concat(MAPPING.zipCodeEndpoint));

export const fetchDealer = (params) => axios.get(CONFIG.ENDPOINT.concat(MAPPING.getDealer), { params });